<template>
    <vs-popup title="Voir une question" :active.sync="isPromptActiveLocal">
        <vs-row>
            <vs-col>
                <feather-icon
                    icon="StarIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                /> {{ singleData.marks }}
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <h6>Question</h6>
                <span>{{ singleData.question }}</span>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <h6>Instructions</h6>
                <span>{{ singleData.instructions }}</span>
            </vs-col>
        </vs-row>
    </vs-popup>
</template>
<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            required: true
        },
        singleData:{
            type: Object,
            default: {}
        }
    },
    watch: {
        isActive(val) {
            if(!val) return;
        }
    },
    computed:{
        isPromptActiveLocal: {
            get() {
                return this.isActive
            },
            set(val) {
                if(!val) {
                    this.$emit('closeDetail')
                }
            }
        },
    },
}
</script>